export { TranslatesService } from './translates.service';
export { ILang } from './translates.interface';
